import { createNamespacedHelpers } from "vuex";

const GARNISH_IMAGE_SIZE = "144x144";
const GARNISH_IMAGE_FULL = "600x600";
const GARNISH_IMAGE_QUALITY = 70;

// shared between the menu row (items without extras book directly) and the
// global booking dialog
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    itemGroup: Object
  },

  data() {
    return {
      extraTabs: [],
      extras: [],
      brokenGarnishImages: {},
      mealsize: null,
      amount: 1
    };
  },

  computed: {
    ...createNamespacedHelpers("Order").mapGetters(["cart"]),

    ...createNamespacedHelpers("Config").mapGetters([
      "images",
      "imageServerBaseUrl",
      "imageServerImagePath",
      "maintenanceMode",
      "offersDelivery",
      "offersPickUp",
      "isDelivery",
      "deliveryInfo",
      "productInfoSettings",
      "enableDeposit",
      "shop"
    ]),

    itemDeposit() {
      return this.enableDeposit ? this.item?.deposit?.price || 0 : 0;
    },

    //total price of item
    itemTotalPrice() {
      //item extras total price
      let extrasTotalPrice = 0;
      let price = 0;
      let discount = 0;
      let total = 0;

      this.extraTabs.forEach(extraTab => {
        extrasTotalPrice += extraTab.garnish.reduce((extras_acc, garnish) => {
          if (extraTab.invertGarnishSelection) {
            return extras_acc - Number(garnish.sell_price) * garnish.amount;
          } else {
            return extras_acc + Number(garnish.sell_price) * garnish.amount;
          }
        }, 0);
      });

      if (this.itemGroup) {
        discount = this.isDelivery
          ? this.itemGroup["delivery discount"]
          : this.itemGroup["takeaway discount"];
      }

      if (this.mealsize) {
        price = this.mealsize.sellPrice;
      } else {
        price = this.isDelivery
          ? this.item["delivery price"]
          : this.item["take away price"];
      }

      total = (price + extrasTotalPrice) * this.amount;
      total -= total * (discount / 100);
      return total + this.itemDeposit * this.amount;
    },

    itemPrice() {
      let price = this.isDelivery
        ? this.item["delivery price"]
        : this.item["take away price"];
      let discount = 0;

      if (this.itemGroup) {
        discount = this.isDelivery
          ? this.itemGroup["delivery discount"]
          : this.itemGroup["takeaway discount"];
      }
      return {
        original: price + this.itemDeposit,
        afterDiscount: price - price * (discount / 100) + this.itemDeposit
      };
    }
  },

  watch: {
    mealsize() {
      this.getExtras();
    }
  },

  methods: {
    resetBooking() {
      this.extras = [];
      this.mealsize = null;
      this.amount = 1;
      this.brokenGarnishImages = {};
      this._garnishUrlCache = {};
    },

    //minus QTY of item
    minus() {
      if (this.amount > 1) this.amount = this.amount - 1;
    },

    //plus QTY of item
    plus() {
      if (this.item && this.item.canBeSoldOncePerOrder) {
        this.$swal({
          title: this.$t("generic.lang_thisItemCanOnlyBeSoldOncePerOrder"),
          icon: "info"
        });

        return;
      }

      this.amount = this.amount + 1;
    },

    //add item selected to cart
    addToCart() {
      if (this.item && this.item.canBeSoldOncePerOrder) {
        let alreadyInOrder = this.cart.some(
          element => element.id === this.item.id
        );

        if (alreadyInOrder) {
          this.$swal({
            title: this.$t("generic.lang_thisItemCanOnlyBeSoldOncePerOrder"),
            icon: "info"
          });
          return;
        }
      }

      this.bookExtras();
      let itemToBook = {
        id: this.item.id,
        name: this.item.name,
        sellPrice: this.isDelivery
          ? this.item["delivery price"]
          : this.item["take away price"],
        description: this.item.description,
        amount: this.amount,
        mealsize: this.mealsize,
        garnish: this.extras,
        deliverPrice: this.item["delivery price"],
        takeAwayPrice: this.item["take away price"],
        discount: this.itemGroup
          ? this.isDelivery
            ? this.itemGroup["delivery discount"]
            : this.itemGroup["takeaway discount"]
          : 0,
        itemGroup: this.itemGroup
          ? {
              id: this.itemGroup.id,
              name: this.itemGroup.name,
              "delivery discount": this.itemGroup["delivery discount"],
              "takeaway discount": this.itemGroup["takeaway discount"]
            }
          : null,
        depositgroupID: this.item?.deposit?.id || null,
        deposit: this.item?.deposit || null,
        canBeSoldOncePerOrder: this.item?.canBeSoldOncePerOrder || false
      };

      this.$store.dispatch("Order/bookItem", itemToBook).then(() => {
        this.resetBooking();
        this.$emit("booked");
      });
    },

    //get all extras Of current item and pushed to extraTabs
    getExtras() {
      let extraTabs = [];

      if (!this.item || !Array.isArray(this.item.extras)) {
        this.extraTabs = extraTabs;
        return;
      }

      this.item.extras.forEach(extra => {
        let items = [];

        extra.garnish.forEach(garnish => {
          if (this.mealsize && this.mealsize.id > 0) {
            if (garnish.sizes && garnish.sizes.length > 0) {
              let size = garnish.sizes.find(
                garnishSize => garnishSize.id === this.mealsize.id
              );
              if (size) {
                items.push({
                  id: garnish.id,
                  name: garnish.name,
                  image: garnish.image,
                  sell_price: size.sellPrice,
                  sellPriceBrutto: size.sellPrice,
                  tax: garnish.tax,
                  amount: 0
                });
              }
            }
          } else {
            if (garnish.sizes && garnish.sizes.length > 0) {
              let size = garnish.sizes.find(
                garnishSize => garnishSize.id === 0
              );
              if (size) {
                items.push({
                  id: garnish.id,
                  name: garnish.name,
                  image: garnish.image,
                  sell_price: size.sellPrice,
                  sellPriceBrutto: size.sellPrice,
                  tax: garnish.tax,
                  amount: 0
                });
              }
            } else {
              items.push({
                id: garnish.id,
                name: garnish.name,
                image: garnish.image,
                sell_price: garnish.sell_price,
                sellPriceBrutto: garnish.sellPriceBrutto,
                tax: garnish.tax,
                amount: 0
              });
            }
          }
        });
        if (items && items.length > 0) {
          extraTabs.push({
            id: extra.id,
            tabName: extra.tabName,
            minChoose: extra.minChoose,
            maxChoose: extra.maxChoose,
            invertGarnishSelection: extra.invertGarnishSelection,
            showImagesInLocalBee: extra.showImagesInLocalBee,
            garnish: items
          });
        }
      });

      this.extraTabs = extraTabs;
    },

    showGarnishImages(tab) {
      return !!(tab && tab.showImagesInLocalBee);
    },

    // garnish images come as bare file names, thumbor builds the final url
    garnishImage(ext) {
      if (!ext || !ext.image || this.brokenGarnishImages[ext.id]) return null;
      if (/^https?:\/\//i.test(ext.image)) return ext.image;

      // cache is non reactive on purpose, the url only depends on ext.id
      const cache = this._garnishUrlCache || (this._garnishUrlCache = {});
      if (cache[ext.id]) return cache[ext.id];

      const base = (this.imageServerBaseUrl || "").replace(/\/+$/, "");
      const path = (this.imageServerImagePath || "").replace(/^\/+|\/+$/g, "");
      if (!base) return null;

      cache[
        ext.id
      ] = `${base}/${GARNISH_IMAGE_SIZE}/filters:quality(${GARNISH_IMAGE_QUALITY})/${path}/${ext.image}`;
      return cache[ext.id];
    },

    // bigger thumbor render, only used by the lightbox
    garnishImageFull(ext) {
      const thumb = this.garnishImage(ext);

      if (!thumb) return null;

      return thumb.replace(
        `/${GARNISH_IMAGE_SIZE}/`,
        `/${GARNISH_IMAGE_FULL}/`
      );
    },

    garnishInitial(ext) {
      return ext && ext.name
        ? ext.name
            .trim()
            .charAt(0)
            .toUpperCase()
        : "";
    },

    markGarnishImageBroken(ext) {
      if (ext) this.$set(this.brokenGarnishImages, ext.id, true);
    },

    //to minus QTY of current extras
    removeExtra(extra) {
      if (extra.amount > 0) {
        extra.amount--;
      }
    },

    //check current garnish as selected and add QTY
    addExtra(extraTab, extra) {
      let totalAmount = this.totalAmountOfCurrentExtras(extraTab);

      if (extraTab.invertGarnishSelection && extra.amount > 0) {
        return;
      }

      if (extraTab.maxChoose > 0 && totalAmount < extraTab.maxChoose) {
        extra.amount++;
      } else if (extraTab.maxChoose === 0) {
        extra.amount++;
      }
    },

    //calcul total Amount of current extras
    totalAmountOfCurrentExtras(extraTab) {
      let totalAmount = extraTab.garnish.reduce((total, extra) => {
        return total + extra.amount;
      }, 0);

      return totalAmount;
    },

    //check limit of all extras is valid
    isValidExtrasLimits(extraTabs) {
      //CHECK EXTRAS MIN / MAX CHOOSE
      let errorAtTab = null;

      if (this.item.sizes && this.item.sizes.length > 0) {
        if (!this.mealsize) {
          return true;
        }
      }

      extraTabs.forEach((extraTab, index) => {
        let totalAmount = extraTab.garnish.reduce((total, extra) => {
          return total + extra.amount;
        }, 0);

        if (extraTab.minChoose > 0 && totalAmount < extraTab.minChoose) {
          errorAtTab = index;
        }

        if (extraTab.maxChoose > 0 && totalAmount > extraTab.maxChoose) {
          errorAtTab = index;
        }
      });

      if (errorAtTab !== null) {
        //ERROR
        return true;
      }

      return false;
    },

    //check garnish selected and add it to extras
    bookExtras() {
      let extras = [];

      this.extraTabs.forEach(extraTab => {
        extraTab.garnish.forEach(extra => {
          if (extra.amount > 0) {
            if (extraTab.invertGarnishSelection) {
              extra.invertGarnishSelection = true;
              extra.removed = true;
              extra.amount = -extra.amount;
              extra.name = this.$t("generic.lang_without") + " " + extra.name;
            }
            extras.push(extra);
            extras[extras.length - 1]["tab_id"] = extraTab.id;
          }
        });
      });

      this.extras = extras;
    }
  }
};
